// extracted by mini-css-extract-plugin
module.exports = {"button":"FixedAddButton_button__1crDZ"};